import { employeeApi } from 'Api/employee';
import { Col, Empty, Row } from 'antd';
import { Loader } from 'components/Global';
import Ellipse from 'components/Global/Ellipse';
import { useEffect, useState } from 'react';
import { toastText } from 'utils/utils';
import styles from './index.module.scss';

const DeductionsModal: React.FC<any> = ({
	employeeId,
	activeTab,
	isUSD,
	setEarningsAmount,
	setEarningsAmountZMW,
	setHasMixedCurrency,
	isLoading,
	setIsLoading,
}) => {
	const [data, setData] = useState<any[]>([]);

	useEffect(() => {
		if (activeTab === 'deductions') {
			fetchEmployeeDeductions();
		}
	}, [activeTab]);

	const fetchEmployeeDeductions = async () => {
		setIsLoading(true);
		try {
			const apiData = await employeeApi.getEmployeeMasterDeductions({
				employeeId,
			});

			const responseData = apiData?.data?.data || [];
			const isPayrollRun = apiData?.data?.isPayrollRun;

			let finalData = isPayrollRun
				? responseData
				: responseData.filter((item: any) => item.isChecked);

			setData(finalData);
			const zmwItems = finalData.filter(
				(item: any) => isUSD && item.currency === 'ZMW'
			);
			const usdItems = finalData.filter(
				(item: any) => !(isUSD && item.currency === 'ZMW')
			);
			const totalUsd = usdItems.reduce(
				(sum: number, item: any) => sum + parseFloat(item?.amount || '0.00'),
				0
			);
			const totalZmw = zmwItems.reduce(
				(sum: number, item: any) => sum + parseFloat(item?.amount || '0.00'),
				0
			);
			setEarningsAmount(totalUsd);
			setEarningsAmountZMW?.(totalZmw);
			setHasMixedCurrency?.(isUSD && zmwItems.length > 0);
		} catch (error: any) {
			if (
				error.response?.data?.message !==
				'Setup Napsa Details in statutory components for selected pay period'
			) {
				toastText(error.response?.data?.message, 'error');
			}
		}
		setIsLoading(false);
	};

	return (
		<>
			{isLoading ? (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '50vh',
					}}
				>
					<Loader />
				</div>
			) : (
				<div className={styles.deductionsContainer}>
					{/* If no data, show "No Data" message */}
					{data.length === 0 ? (
						<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
					) : (
						<Row gutter={16}>
							{data.map((item: any) => (
								<Col
									key={item.id || item.description}
									span={12}
									className={styles.deductionsItem}
								>
									<div className={styles.deductionsContent}>
										<div className={styles.labelContainer}>
											<Ellipse
												maxLength={20}
												message={item?.description?.toUpperCase()}
												isTooltip={true}
												tooltipMessage={item?.description?.toUpperCase()}
												key={item?.description?.toUpperCase()}
											/>
										</div>
										<span className={styles.colon}>:</span>
										{/* :{' '} */}
										<div className={styles.amount}>
											{item.amount}{' '}
											<span
												className={`${styles.rowCurrencyLabel} ${isUSD && item.currency === 'ZMW'
														? styles.currencyZmw
														: isUSD
															? styles.currencyUsd
															: styles.currencyZmw
													}`}
											>
												{isUSD && item.currency === 'ZMW' ? 'ZMW' : isUSD ? 'USD' : 'ZMW'}
											</span>
										</div>
									</div>
								</Col>
							))}
						</Row>
					)}
				</div>
			)}
		</>
	);
};

export default DeductionsModal;
